import React from "react";
import { FormattedMessage } from "react-intl";

import { Icon, glyphs, COLORS, Button } from "@treelab/panda";

import { Container, MessageContainer } from "./styled";

interface IProps {
  add: () => void;
}

const AddButton: React.FC<IProps> = ({ add }) => {
  return (
    <Container>
      <Button icon={glyphs.ADD_V2} onClick={add} buttonType="text" colorTheme="blue">
        <FormattedMessage id="form.label.filter.add" />
      </Button>
    </Container>
  );
};

export default AddButton;
